import { render, staticRenderFns } from "./RsaSchedaInfermieristicaModalEditComponent.vue?vue&type=template&id=32873a46"
import script from "./RsaSchedaInfermieristicaModalEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaInfermieristicaModalEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports